import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import useProfileAPI from 'features/profile2.0/hooks/useProfileAPI';
import useAuth from 'hooks/useAuth';
import usePortalModal from 'hooks/usePortalModal';
import {
  PII_PROFILE_PENDING_DOCUMENTS_STATUS,
  PROFILE_ALREADY_REGISTRED_STATUS,
  PROFILE_PENDING_OTP_VERIFICATION_STATUS,
  PROFILE_SHOW_CONTACT_US_STATUS,
} from '../const';
import usePIIAPI from './usePIIAPI';
import usePIIStore from './usePIIStore';

const usePII = () => {
  const { showPortalModalName, closePortalModalName } = usePortalModal();

  const { signupPIIRequest } = usePIIAPI();
  const { refreshToken } = useAuth();
  const { getProfileRequest } = useProfileAPI();
  const { personalDetails, residentialAddress, setLoading } = usePIIStore();

  const handleShowPIIVerifyNowModal = () => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.PII_VERIFY_NOW_MODAL,
      action: handleShowFormPIIModal,
    });
  };

  const handleShowFormPIIModal = () => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.FORM_PII_MODAL,
      });
      clearTimeout(timer);
    }, 100);
  };

  const handleShowFormPIIVerificationSuccessfulModal = () => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.FORM_PII_VERIFICATION_SUCCESSFUL_MODAL,
      });
      clearTimeout(timer);
    }, 100);
  };

  const handleShowFormPIIOTPVerificationModal = () => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.FORM_PII_OTP_VERIFICATION_MODAL,
      });
      clearTimeout(timer);
    }, 100);
  };

  const handleShowFormPIIProfileDetailsExistInformModal = () => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.FORM_PII_PROFILE_DETAILS_EXIST_INFORM_MODAL,
      });
      clearTimeout(timer);
    }, 100);
  };

  const handleShowFormPIIProfileContactUsModal = () => {
    const timer = setTimeout(() => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.FORM_PII_PROFILE_CONTACT_US_MODAL,
      });
      clearTimeout(timer);
    }, 100);
  };

  const handleSubmitSignupPII = async ({
    personalDetailsInformation,
    residentialAddressInformation,
  }) => {
    console.log(
      `⭐ usePII 👉 handleSubmitSignupPII ➡️ personalDetailsInformation ↩`,
      personalDetailsInformation
    );
    console.log(
      `⭐ usePII 👉 handleSubmitSignupPII ➡️ residentialAddressInformation ↩`,
      residentialAddressInformation
    );
    /* BEGIN Process: 
      1. POST /profile/pii
      2. OST /auth/refresh
      3. GET /profile
      4. FormPIIProfileResult 
    */
    signupPIIRequest({
      personalDetailsInformation,
      residentialAddressInformation,
      callback: () => {
        refreshToken((newToken) => {
          let { data } = getProfileRequest(newToken);
          setLoading(false);
          /* CASE 1 - BEGIN PENDING_ID_DOCUMENTS */
          // data = {
          //   ...data,
          //   status: 'PENDING_ID_DOCUMENTS',
          // };
          /* CASE 1 - END */
          /* CASE 2 - BEGIN PENDING_OTP_VERIFICATION */
          // data = {
          //   ...data,
          //   status: 'PENDING_OTP_VERIFICATION',
          // };
          /* CASE 2 - END */
          /* CASE 3 - BEGIN ALREADY_REGISTRED */
          // data = {
          //   ...data,
          //   status: 'ALREADY_REGISTRED',
          // };
          /* CASE 3 - END */
          /* CASE 4 - BEGIN SHOW_CONTACT_US */
          // data = {
          //   ...data,
          //   status: 'SHOW_CONTACT_US',
          // };
          /* CASE 4 - END */
          const profileStatus = data?.status;
          const isVerificationSuccessful =
            profileStatus === PII_PROFILE_PENDING_DOCUMENTS_STATUS;
          const isPendingOTPVerification =
            profileStatus === PROFILE_PENDING_OTP_VERIFICATION_STATUS;
          const isAlreadyRegistred =
            profileStatus === PROFILE_ALREADY_REGISTRED_STATUS;
          const isShowContactUs =
            profileStatus === PROFILE_SHOW_CONTACT_US_STATUS;
          if (isVerificationSuccessful) {
            handleShowFormPIIVerificationSuccessfulModal();
            return;
          }
          if (isPendingOTPVerification) {
            handleShowFormPIIOTPVerificationModal();
            return;
          }
          if (isAlreadyRegistred) {
            handleShowFormPIIProfileDetailsExistInformModal();
            return;
          }
          if (isShowContactUs) {
            handleShowFormPIIProfileContactUsModal();
            return;
          }
        });
      },
      errorCallback: () => {
        setLoading(false);
      },
    });
    /* END Process */
  };

  return {
    showPortalModalName,
    closePortalModalName,
    handleShowPIIVerifyNowModal,
    handleShowFormPIIModal,
    handleShowFormPIIVerificationSuccessfulModal,
    handleShowFormPIIOTPVerificationModal,
    handleShowFormPIIProfileDetailsExistInformModal,
    handleShowFormPIIProfileContactUsModal,
    handleSubmitSignupPII,
  };
};

export default usePII;
